import {COUNTRIES} from 'common/report/constants';

const countriesToFilter = new Set([
  ``,
  `country_iso_code`,
  `A1`,
  `A2`,
  `AX`,
]);

const topCountries = [
  [`US`, `United States`],
  [`GB`, `United Kingdom`],
  [`CA`, `Canada`],
];

export function getCountryDropdownOptions() {
  const sortedCountries = Object.entries(COUNTRIES)
    .filter(([code, country]) => !countriesToFilter.has(code)) // eslint-disable-line no-unused-vars
    .sort((a, b) => a[1] > b[1] ? 1 : -1);
  return [topCountries, sortedCountries];
}
